<template>
  <input-field
    v-model="password"
    :rules="rules"
    :type="show ? 'text' : 'password'"
    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
    @append="show = !show"
    :label="label"
  >
  </input-field>
</template>
<script>
import InputField from "@/components/ui/form/InputField.vue";

export default {
  components: { InputField },
  props: {
    label: {
      type: String,
      default: "Password",
    },
    value: {
      type: String,
      default: "",
    },
    rules: {
      type: String,
      default: "required",
    },
  },
  data() {
    return {
      show: false,
      password: "",
    };
  },
  watch: {
    password(newVal) {
      this.$emit("input", newVal);
    },
    value(newVal) {
      this.password = newVal;
    },
  },
};
</script>
